import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useRecoilValue } from 'recoil';
import { translationsState } from '../../../../../atoms/translation/translation.atom';
import { translate } from '../../../../../utils/translation/translation';
import {
  clearLocalStorageValue,
  getLocalStorageValue,
  LocalStorageKey,
  setLocalStorageValue,
} from '../../../../../utils/localStorage/localStorage';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../../../../config/routes/routes';
import ErrorFallback from '../../../../common/ErrorFallback/ErrorFallback';

export const ErrorPage = () => {
  const translations = useRecoilValue(translationsState);
  const navigate = useNavigate();

  const [isRepeat] = useState(
    getLocalStorageValue(LocalStorageKey.errorRepeat) ?? false,
  );

  useEffect(() => {
    if (!isRepeat) {
      setLocalStorageValue(LocalStorageKey.errorRepeat, true);
      window.location.reload();
    } else {
      clearLocalStorageValue(LocalStorageKey.errorRepeat);
    }
  }, []);

  if (!isRepeat) {
    return null;
  }

  return (
    <>
      <Helmet>
        {/* prerender service converts this into a real HTTP 503 for crawlers,
            so a rendering failure never gets indexed as an empty 200 page.
            Deliberately NO robots noindex: Google does not index a snapshot
            as served, it runs the snapshot's scripts again. A snapshot taken
            by an earlier build points at chunks a later deploy removed, the
            chunk load fails in Google's renderer, and this page used to tell
            Google to drop a perfectly good URL (measured 2026-10-02, the
            2026-09-24 impressions collapse). The 503 alone keeps a failed
            prerender out of the snapshot cache. */}
        <meta name="prerender-status-code" content="503" />
      </Helmet>
      <ErrorFallback
        title={translate(translations, 'ERROR_PAGE.TITLE')}
        subtitle={translate(translations, 'ERROR_PAGE.SUBTITLE')}
        image={'https://ababa-tech.ams3.digitaloceanspaces.com/public/500.svg'}
        buttonText={translate(translations, 'ERROR_PAGE.GO_TO_HOME')}
        onButtonClick={() => navigate(routes.homepage)}
      />
    </>
  );
};

export default ErrorPage;
